import { component } from "picoapp";
import { type Context, type TablescapeState } from "../../state";
import { TablescapeEvent, TablescapeContext } from "@tablescape/context";

function updateCartBubble(node: HTMLElement, cartItemCount: number) {
  const cartBubble = node.querySelector<HTMLSpanElement>(".js-cart-bubble");
  const cartCountElement = node.querySelector<HTMLElement>(".js-cart-count");

  if (cartItemCount) {
    cartBubble?.classList.remove("hidden");

    const textNode = cartCountElement?.querySelector(
      "[data-tbsp-component='text']"
    );
    if (cartCountElement && textNode) {
      textNode.textContent = String(cartItemCount);
    }
  } else {
    cartBubble?.classList.add("hidden");
  }

  const srOnlyElement = node.querySelector<HTMLSpanElement>(".sr-only");
  if (srOnlyElement && cartCountElement) {
    const label =
      cartCountElement.dataset.srOnlyLabel?.trim() ??
      srOnlyElement.textContent?.trim() ??
      "";
    srOnlyElement.textContent = label
      ? `${cartItemCount} ${label}`
      : String(cartItemCount);
  }
}

function toggleCart(node: HTMLElement) {
  node.addEventListener("click", () => {
    TablescapeContext.emit(TablescapeEvent.TOGGLE_CART, {
      ui: {
        cartDrawerOpen: true,
        cartDrawerUserToggled: true,
        giftNoteDrawerOpen: false,
        productVariantDrawerOpen: false,
      },
    });
  });

  TablescapeContext.on(
    TablescapeEvent.UPDATE_CART_ITEM_COUNT,
    (data?: TablescapeState) => {
      updateCartBubble(node, data?.cart?.quantity ?? 0);
    }
  );
}

export const cartDrawerToggle = component<Context>((node) => {
  toggleCart(node);
});
